import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { css, styled } from "styled-components"

const Root = styled.div`
  position: relative;

  select {
    height: var(--space-8);
    padding-inline: var(--space-2);

    ${(props) => props.$action && css`
      border-color: var(--color-theme-accent-400);
      color: var(--color-theme-accent-400);
    `}

    &:disabled {
      opacity: 0.33;
      pointer-events: none;

      + div {
        opacity: 0.33;
      }
    }
  }
`;

const Icon = styled.div`
  position: absolute;
  right: var(--space-2);
  top: 50%;
  translate: 0 -50%;

  ${(props) => props.$action && css`
    color: var(--color-theme-accent-400);
  `}
`;

function Select({ children, selected, onChange, onBlur, disabled, $action }) {
  return (
    <Root $action={$action}>
      <select value={selected} onChange={onChange} onBlur={onBlur} disabled={disabled}>{children}</select>
      <Icon>
        <FontAwesomeIcon icon={faAngleDown} />
      </Icon>
    </Root>
  )
}

export default Select;
